import { useNavigate } from 'react-router-dom';

export default function History() {
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-xl font-bold mb-4">Consumption History</h1>
      <p className="mb-4 text-gray-700">This page will list the user's logged days and meals.</p>
      <button onClick={() => navigate(-1)} className="px-4 py-2 bg-gray-300 rounded">⬅ Back</button>
    </div>
  );
}
